"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IllustratedFeatureList = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _framerMotion = require("framer-motion");

var _styles = require("./shared/styles");

var _excluded = ["inverse", "features", "bgColor", "alignment", "lockUpHeight"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb14"
} : {
  target: "e17x1cgb14",
  label: "Wrapper"
})(_styles.pageMargins, ";display:flex;align-items:center;flex-direction:column;padding-bottom:0;padding-top:3rem;@media (min-width: ", _styles.breakpoints[1], "px){padding-top:5rem;}@media (min-width: ", _styles.breakpoints[2], "px){display:grid;justify-content:center;align-items:flex-start;grid-template-columns:repeat(2, minmax(auto, 1fr));grid-template-rows:minmax(50vh, max-content);gap:80px;padding-top:7rem;}@media (min-width: ", _styles.breakpoints[3], "px){grid-template-columns:repeat(2, minmax(auto, 1fr));}@media (min-width: 1416px){grid-template-columns:repeat(2, 1fr);}");
var Title = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb13"
} : {
  target: "e17x1cgb13",
  label: "Title"
})("font-weight:", _styles.typography.weight.extrabold, ";font-size:", _styles.typography.size.s3, "px;line-height:24px;color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";");
var Description = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb12"
} : {
  target: "e17x1cgb12",
  label: "Description"
})("font-size:", _styles.typography.size.s3, ";line-height:24px;color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";");
var IconWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb11"
} : {
  target: "e17x1cgb11",
  label: "IconWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "ecm7kw",
  styles: "svg{display:block;margin-right:20px;height:40px;width:40px;flex:none;}"
} : {
  name: "ecm7kw",
  styles: "svg{display:block;margin-right:20px;height:40px;width:40px;flex:none;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Feature = (0, _theming.styled)("button", process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb10"
} : {
  target: "e17x1cgb10",
  label: "Feature"
})("border:1px solid ", function (props) {
  return props.inverse ? 'rgba(255 255 255 / 10%)' : _styles.color.border;
}, ";background-color:", function (props) {
  return props.inverse ? '#0E0C2A' : _styles.color.lightest;
}, ";border-radius:", _styles.spacing.borderRadius.small, "px;text-align:left;display:flex;width:100%;padding:20px;align-items:center;cursor:pointer;transition:all 150ms ease-out;transform:translate3d(0, 0, 0);outline:0;&:hover,&:focus{border-color:", _styles.color.secondary, ";transform:translate3d(0, -3px, 0);box-shadow:", function (props) {
  return props.inverse ? 'rgba(0 0 0 / 50%)' : 'rgba(0 0 0 8%)';
}, " 0 3px 10px 0;}&:active,&[aria-pressed='true']{border-color:", _styles.color.secondary, ";transform:translate3d(0, 0, 0);}");
var FeatureList = (0, _theming.styled)("ul", process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb9"
} : {
  target: "e17x1cgb9",
  label: "FeatureList"
})("order:", function (props) {
  return props.alignment === 'left' ? 2 : 1;
}, ";display:flex;flex-direction:column;gap:20px;padding:0;margin:0;width:100%;min-width:0;li{list-style:none;margin:0;}");
var FeatureMedia = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb8"
} : {
  target: "e17x1cgb8",
  label: "FeatureMedia"
})("border-radius:", _styles.spacing.borderRadius["default"], "px;position:relative;overflow:hidden;background-color:", function (props) {
  return props.bgColor;
}, ";video{display:block;width:100%;height:100%;object-fit:contain;}a{background-color:rgba(0 0 0 / 50%);position:absolute;top:20px;right:20px;&:hover,&:focus,&:active{background-color:rgba(0 0 0 / 50%);}svg{margin:0;}}");
var FeatureMediaLarge = ( /*#__PURE__*/0, _theming.styled)(FeatureMedia, process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb7"
} : {
  target: "e17x1cgb7",
  label: "FeatureMediaLarge"
})("order:", function (props) {
  return props.alignment === 'left' ? 1 : 2;
}, ";display:none;height:100%;overflow:hidden;min-height:", function (props) {
  return props.lockUpHeight;
}, "px;@media (min-width: ", _styles.breakpoints[2], "px){display:block;", function (props) {
  return props.alignment === 'left' ? /*#__PURE__*/(0, _theming.css)("margin-left:calc(-", _styles.pageMargin, "vw - 20px);border-top-left-radius:0;border-bottom-left-radius:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:FeatureMediaLarge;")) : /*#__PURE__*/(0, _theming.css)("margin-right:calc(-", _styles.pageMargin, "vw - 20px);border-top-right-radius:0;border-bottom-right-radius:0;a{left:20px;right:unset;}" + (process.env.NODE_ENV === "production" ? "" : ";label:FeatureMediaLarge;"));
}, ";}@media (min-width: ", _styles.breakpoints[3], "px){", function (props) {
  return props.alignment === 'left' ? /*#__PURE__*/(0, _theming.css)("margin-left:calc(-", _styles.pageMargin * 2, "vw - 20px);" + (process.env.NODE_ENV === "production" ? "" : ";label:FeatureMediaLarge;")) : /*#__PURE__*/(0, _theming.css)("margin-right:calc(-", _styles.pageMargin * 2, "vw - 20px);" + (process.env.NODE_ENV === "production" ? "" : ";label:FeatureMediaLarge;"));
}, ";max-height:", function (props) {
  return props.lockUpHeight;
}, "px;}@media (min-width: 1416px){margin-left:0;margin-right:0;border-radius:", _styles.spacing.borderRadius["default"], "px;}");
FeatureMediaLarge.defaultProps = {
  lockUpHeight: 640
};
var FeatureMediaSmall = ( /*#__PURE__*/0, _theming.styled)(FeatureMedia, process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb6"
} : {
  target: "e17x1cgb6",
  label: "FeatureMediaSmall"
})("display:block;aspect-ratio:1/1;@media (min-width: ", _styles.breakpoints[2], "px){display:none;}");
var MediaWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb5"
} : {
  target: "e17x1cgb5",
  label: "MediaWrapper"
})("display:block;@media (min-width: ", _styles.breakpoints[2], "px){display:none;}");
var BackdropVideo = (0, _theming.styled)("video", process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb4"
} : {
  target: "e17x1cgb4",
  label: "BackdropVideo"
})(process.env.NODE_ENV === "production" ? {
  name: "olria4",
  styles: "position:absolute;top:0;width:100%;transform:scale(1.25);filter:blur(10px);user-select:none;pointer-events:none"
} : {
  name: "olria4",
  styles: "position:absolute;top:0;width:100%;transform:scale(1.25);filter:blur(10px);user-select:none;pointer-events:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Video = (0, _theming.styled)("video", process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb3"
} : {
  target: "e17x1cgb3",
  label: "Video"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var MotionDivMobile = ( /*#__PURE__*/0, _theming.styled)(_framerMotion.motion.div, process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb2"
} : {
  target: "e17x1cgb2",
  label: "MotionDivMobile"
})(process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "d3v9zr",
  styles: "overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var MotionDivDesktop = ( /*#__PURE__*/0, _theming.styled)(_framerMotion.motion.div, process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb1"
} : {
  target: "e17x1cgb1",
  label: "MotionDivDesktop"
})(process.env.NODE_ENV === "production" ? {
  name: "j2pfbl",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0"
} : {
  name: "j2pfbl",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var duration = 0.3;
var variants = {
  enter: function enter(direction) {
    return {
      y: direction === 'up' ? '-5%' : '5%',
      opacity: 0,
      transition: {
        duration: duration
      }
    };
  },
  center: {
    y: '0%',
    opacity: 1,
    zIndex: 1,
    transition: {
      duration: duration,
      delay: 0.2
    }
  },
  exit: function exit(direction) {
    return {
      zIndex: 0,
      y: direction === 'up' ? '5%' : '-5%',
      opacity: 0,
      transition: {
        duration: duration
      }
    };
  }
};
var LinkButton = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Button, process.env.NODE_ENV === "production" ? {
  target: "e17x1cgb0"
} : {
  target: "e17x1cgb0",
  label: "LinkButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1v771ry",
  styles: "z-index:3"
} : {
  name: "1v771ry",
  styles: "z-index:3",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var IllustratedFeatureList = function IllustratedFeatureList(_ref) {
  var inverse = _ref.inverse,
      features = _ref.features,
      bgColor = _ref.bgColor,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? 'left' : _ref$alignment,
      lockUpHeight = _ref.lockUpHeight,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var activeFeature = features[activeIndex];

  var _useState3 = (0, _react.useState)('down'),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      direction = _useState4[0],
      setDirection = _useState4[1];

  return /*#__PURE__*/_react["default"].createElement(Wrapper, props, /*#__PURE__*/_react["default"].createElement(FeatureMediaLarge, {
    alignment: alignment,
    bgColor: bgColor,
    lockUpHeight: lockUpHeight
  }, /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
    initial: false,
    custom: direction
  }, /*#__PURE__*/_react["default"].createElement(MotionDivDesktop, {
    key: activeFeature.title,
    custom: direction,
    variants: variants,
    initial: "enter",
    animate: "center",
    exit: "exit"
  }, /*#__PURE__*/_react["default"].createElement(BackdropVideo, {
    src: activeFeature.media,
    playsInline: true
  }), /*#__PURE__*/_react["default"].createElement(Video, {
    src: activeFeature.media,
    autoPlay: true,
    loop: true,
    playsInline: true,
    muted: true,
    poster: activeFeature.poster
  }))), /*#__PURE__*/_react["default"].createElement(LinkButton, {
    size: "small",
    appearance: "inverse",
    href: activeFeature.link.href,
    ButtonWrapper: activeFeature.link.LinkWrapper,
    isLink: true
  }, activeFeature.link.label, " ", /*#__PURE__*/_react["default"].createElement(_designSystem.Icon, {
    icon: "arrowright"
  }))), /*#__PURE__*/_react["default"].createElement(FeatureList, {
    alignment: alignment
  }, features.map(function (feature, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: feature.title
    }, /*#__PURE__*/_react["default"].createElement(Feature, {
      "aria-pressed": index === activeIndex ? 'true' : 'false',
      inverse: inverse,
      onClick: function onClick() {
        setDirection(index > activeIndex ? 'down' : 'up');
        setActiveIndex(index);
      }
    }, /*#__PURE__*/_react["default"].createElement(IconWrapper, null, feature.icon), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Title, {
      inverse: inverse
    }, feature.title), /*#__PURE__*/_react["default"].createElement(Description, {
      inverse: inverse
    }, feature.description))), /*#__PURE__*/_react["default"].createElement(MediaWrapper, null, /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
      initial: false
    }, index === activeIndex && /*#__PURE__*/_react["default"].createElement(MotionDivMobile, {
      layout: true,
      key: feature.title,
      initial: "collapsed",
      animate: "open",
      exit: "collapsed",
      variants: {
        open: {
          opacity: 1,
          height: 'auto',
          marginTop: 20
        },
        collapsed: {
          opacity: 0,
          height: 0,
          marginTop: 0
        }
      },
      transition: {
        duration: 0.4,
        ease: [0.04, 0.62, 0.23, 0.98]
      }
    }, /*#__PURE__*/_react["default"].createElement(FeatureMediaSmall, {
      bgColor: bgColor
    }, /*#__PURE__*/_react["default"].createElement("video", {
      src: feature.media,
      autoPlay: true,
      loop: true,
      playsInline: true,
      preload: "auto",
      poster: feature.poster
    }), /*#__PURE__*/_react["default"].createElement(_designSystem.Button, {
      size: "small",
      appearance: "inverse",
      href: feature.link.href,
      ButtonWrapper: feature.link.LinkWrapper,
      isLink: true
    }, feature.link.label, " ", /*#__PURE__*/_react["default"].createElement(_designSystem.Icon, {
      icon: "arrowright"
    })))))));
  })));
};

exports.IllustratedFeatureList = IllustratedFeatureList;